<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>

    <div v-if="data.header" class="model model-header">
      <div class="spacer">&nbsp;</div>
      <div class="header-wrapper">
        <div class="header-left">
          <label v-html="getModelHeaderLeft()"></label>
        </div>
        <div class="header-right">
          <label v-html="getModelHeaderRight()"></label>
        </div>
      </div>
      <div class="header-other">
        <label v-html="getModelHeaderOther()"></label>
      </div>
    </div>

    <div class="model">
      <div class="spacer">&nbsp;</div>
      <div v-for="(model, index) in data.model" :key="index" class="header">
        <label v-html="getModelText(model.label)"></label>
      </div>
    </div>

    <div v-for="(choice, index) in getChoices" :key="index" class="multiple-item">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_${choice.id}`" v-html="getChoiceText(choice.id)">
        </label>

        <template v-if="isSpecial(choice)">
          <label>
            <input type="text"
              class="input-special"
              :ref="`custom_${choice.id}`"
              @keyup="setCustomValue(choice)"
            />
          </label>
        </template>

        <template v-else>
          <label :for="`input_${choice.id}_${modelIdx}`" v-for="(model, modelIdx) in data.model" :key="modelIdx">
            <input type="radio"
              :id="`input_${choice.id}_${modelIdx}`"
              :name="`input[${choice.id}]`"
              :ref="`input[${choice.id}]`"
              :value="model.value"
              @change="selected(choice, model.value)"
            />
          </label>
        </template>

      </div>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >Next</button>

    <!-- <p>{{ answer.choices }}</p> -->

  </form>
</template>

<script>
export default {
    name: 'multiple-table-radio',

    props: {
      data: {
        required: true,
        type: Object
      },
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            customValue: ''
        }
    },

    created() {
      this.data.choices.forEach(choice => {
        if( choice.pushed ) {
          this.answer.choices.push({
            id: choice.id,
            custom: 0
          })
        }
      });
    },

    mounted() {
    },

    methods: {
        selected(choice, value){
            let index = this.answer.choices.findIndex(c => c.id === choice.id)
            if ( index > -1 ){
              this.answer.choices.splice(index, 1)
            }
            this.answer.choices.push({
              id: choice.id,
              custom: value
            })
        },

        setCustomValue(choice) {
          console.log('setCustomValue %s', choice.id)
          this.selected(choice, `0:${this.$refs[`custom_${choice.id}`][0].value.trim()}`)
        },

        next(){
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        isChecked(choiceId) {
          return this.answer.choices.find(c => c.id === choiceId) ? 'active' : '';
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].text[textIndex].html;
        },

        getModelText(model) {
          const index = model.findIndex(m => m.lang == this.$parent.lang);
          return model[index].html;
        },

        getModelHeaderLeft() {
          const index = this.data.header.left.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.left[index].html;
        },

        getModelHeaderRight() {
          const index = this.data.header.right.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.right[index].html;
        },

        getModelHeaderOther() {
          const index = this.data.header.other.findIndex(h => h.lang == this.$parent.lang);
          return this.data.header.other[index].html;
        },

      isSpecial(choice) {
          return choice.special
      }

    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      },

      getChoices() {
        let nchoices = [];
        let answers = this.$parent.answers;
        let doifs = this.data.doifs;
        let hides = [];
        if ( doifs !== false ){
          doifs.forEach(d => {
            let group = d.group;
            group.forEach(g => {
              answers.forEach(a => {
                a.choices.forEach(ch => {
                  if(ch.id == g.idchoice && ch.custom == g.value){
                    hides.push(g.hide)
                  }
                });
              });
            })
          })
        }
        if ( hides.length > 0 ){
          nchoices = this.data.choices.filter(choice => {
            return ! hides.includes(choice.id)
          });
          return nchoices;
        } else {
          return this.data.choices;
        }
      }
    },

    watch: {
      'answer.choices': function(val) {
        if( val.length < this.getChoices.length ){
          this.nextBtnDisabled = true
        } else {
          this.nextBtnDisabled = false
        }
      }
    }

}
</script>